import { useEffect, useState } from 'react';
import CountDownBlock from './CountDownBlock';

const TIME_THRESHOLD = 30;

const ModalCountDown = ({
  time,
  onFinish,
}: {
  time: number; //utc time
  onFinish?: () => void;
}) => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [countdownDuration, setCountdownDuration] = useState(0);

  useEffect(() => {
    let intervalId: NodeJS.Timer | null = null;

    const calculateTimeLeft = () => {
      const now = Math.floor(Date.now() / 1000);
      const timePassed = time - now;

      if (timePassed >= 0 && timePassed <= TIME_THRESHOLD) {
        setShowCountdown(true);
        setCountdownDuration(timePassed);

        if (intervalId) {
          clearInterval(intervalId);
        }
      }
    };

    calculateTimeLeft();

    const now = Math.floor(Date.now() / 1000);

    if (now < time) {
      intervalId = setInterval(calculateTimeLeft, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [time]);

  if (showCountdown) {
    return <CountDownBlock timeInSec={countdownDuration} onFinish={onFinish} />;
  }

  return null;
};

export default ModalCountDown;
